import * as React from 'react'
import { useTranslation } from 'react-i18next'

function pad(value: number): string {
  return String(value).padStart(2, '0')
}

interface CountdownTilesProps<U extends string> {
  /** Object containing numeric values for each unit key */
  values: Record<U, number>
  /** Ordered list of unit keys to display */
  units: readonly U[]
  /** i18n key prefix — each unit is resolved as `${prefix}.${unit}` */
  i18nPrefix: string
}

export function CountdownTiles<U extends string>({
  values,
  units,
  i18nPrefix,
}: CountdownTilesProps<U>) {
  const { t } = useTranslation('banners')
  return (
    <div className="flex items-center gap-1.5">
      {units.map((unitKey, index) => (
        <React.Fragment key={unitKey}>
          <div className="flex min-w-[40px] flex-col items-center rounded-2 bg-[rgba(255,255,255,0.15)] px-1.5 py-0.5">
            <span className="typography-14 text-service-white-white font-bold tabular-nums">
              {pad(values[unitKey])}
            </span>
            <span className="typography-11 text-service-white-white/80">
              {t(`${i18nPrefix}.${unitKey}` as never)}
            </span>
          </div>
          {index < units.length - 1 ? (
            <span className="typography-14 text-service-white-white font-bold">:</span>
          ) : null}
        </React.Fragment>
      ))}
    </div>
  )
}
